import React, { useMemo } from "react";
import { NoteForm } from "@qjumpers/common-ui";
import { useRecoilValue, useSetRecoilState } from "recoil";
import schemaData from "./schema/noteFormSchema.json";
import uiSchema from "./schema/noteFormUiSchema.json";
import { toastMessageState } from "../../recoil/toast/atom";
import { addNote, loadEmailByNote, loadNotes } from "../../requests/notes";
import { customFields } from "../../FormComponents/Fields";
import { noteTypesData } from "../../recoil/notetypes/atom";
import { getDocumentUrl } from "../../requests/documents";

export const NoteFormWrapper = (props) => {
  const popToast = useSetRecoilState(toastMessageState);
  const noteTypes = useRecoilValue(noteTypesData);

  const isAddNoteEnabled = useMemo(() => {
    const { initialValues, supportATSOperations, hasManageRights } = props;
    return initialValues.note.entityType !== "application" ||
      (initialValues.note.entityType === "application" && supportATSOperations && hasManageRights)
      ? true
      : false;
  }, [props.initialValues, props.supportATSOperations, props.hasManageRights]);

  const setNoteTypeId = (note) => {
    const filteredNoteTypes = noteTypes.filter((note) => note.name === "Employment Document");

    note.noteTypeId = filteredNoteTypes[0].id;
  };

  return (
    <>
      <NoteForm
        addNote={addNote}
        callFrom={props.callFrom}
        candidateId={props.candidateId}
        customFields={customFields}
        document={document}
        emailStatus={props.emailStatus}
        getDocumentUrl={getDocumentUrl}
        hasCommunicationRights={props.hasCommunicationRights}
        hasPanelMemberViewRights={props.hasPanelMemberViewRights}
        initialValues={props.initialValues}
        isAddNoteEnabled={isAddNoteEnabled}
        jobId={props.jobId}
        loadEmailByNote={loadEmailByNote}
        loadNotes={loadNotes}
        noteTypes={noteTypes}
        documentCategories= {[]}
        popToast={popToast}
        relatedObject={props.relatedObject}
        setNoteTypeId={setNoteTypeId}
        showNotesButton={props.showNotesButton}
        schemaData={schemaData}
        uiSchema={uiSchema}
      />
    </>
  );
};
